define(['basemodel'], (BaseModel) => BaseModel.extend({
    prefix () {
        return `/projects/${this.get('project_id')}`;
    }
}));
